import { portfolioData, contactInfo } from '../../../mocks/portfolio';

export default function Footer() {
  const { about } = portfolioData;

  return (
    <footer className="bg-[#000000] text-white py-20">
      <div className="container mx-auto px-6 lg:px-12">
        {/* Top Section */}
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-16 mb-16">
          {/* Left Area - Brand */}
          <div className="lg:col-span-4">
            <h3 className="text-6xl font-black mb-12">
              {portfolioData.hero.name.split(' ')[0]}
            </h3>
            <p className="text-white text-base leading-relaxed mb-10 max-w-sm">
              デジタルとアナログの境界を超えて、人々の心に響くデザインを追求しています。
              ユーザー体験を第一に考え、美しさと機能性を両立させたデザインソリューションを提供します。
            </p>
            <div className="flex gap-4">
              {about.profile.social.map((social, index) => (
                <a 
                  key={index}
                  href={social.url}
                  className="w-12 h-12 rounded-full border-2 border-white/30 flex items-center justify-center text-white hover:bg-white hover:text-black transition-all duration-300 cursor-pointer"
                >
                  <i className={social.icon}></i>
                </a>
              ))}
            </div>
          </div>

          {/* Center Area - Contact Info */}
          <div className="lg:col-span-5 space-y-12">
            <div>
              <h4 className="text-white text-xs uppercase tracking-wider mb-3 font-semibold">
                Location
              </h4>
              <p className="text-white text-base leading-relaxed">
                {contactInfo.location}
              </p>
            </div>
            <div>
              <h4 className="text-white text-xs uppercase tracking-wider mb-3 font-semibold">
                Contact
              </h4>
              <p className="text-white text-base leading-relaxed">
                {contactInfo.phone}
              </p>
            </div>
            <div>
              <h4 className="text-white text-xs uppercase tracking-wider mb-3 font-semibold">
                Email
              </h4>
              <p className="text-white text-base leading-relaxed">
                {contactInfo.email}
              </p>
            </div>
          </div>

          {/* Right Area - Portrait */}
          <div className="lg:col-span-3">
            <div className="h-full min-h-[400px]">
              <img 
                src="https://readdy.ai/api/search-image?query=professional%20young%20japanese%20female%20designer%20portrait%20in%20monochrome%2C%20confident%20upward%20gaze%2C%20modern%20minimalist%20style%2C%20high%20contrast%20black%20and%20white%20photography%2C%20elegant%20composition%2C%20studio%20lighting&width=600&height=900&seq=footer1&orientation=portrait"
                alt="Profile"
                className="w-full h-full object-cover rounded-lg"
              />
            </div>
          </div>
        </div>

        {/* Bottom Section */}
        <div className="border-t border-white/10 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-white text-sm">
            © 2025 {portfolioData.hero.name}. All rights reserved.
          </p>
          <div className="flex gap-8">
            <a href="#" className="text-white text-sm hover:text-[#d4c5b9] transition-colors cursor-pointer">
              Privacy Policy
            </a>
            <a href="#" className="text-white text-sm hover:text-[#d4c5b9] transition-colors cursor-pointer">
              Terms of Service
            </a>
            <a href="#" className="text-white text-sm hover:text-[#d4c5b9] transition-colors cursor-pointer">
              Contact
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}